import './MessagingChannelPreview.css';
import {
  Avatar,
  ChannelPreviewUIComponentProps,
  DefaultStreamChatGenerics,
  useChatContext,
} from 'stream-chat-react';
import { getChannelName, getTimeStamp } from '../../helpers';
import { clsx } from 'clsx';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { Typography } from '@design-system/components/typography/typography';

type MessagingChannelPreviewProps =
  ChannelPreviewUIComponentProps<DefaultStreamChatGenerics> & {
    blockChannel: (id: string) => void;
    showUserInfo: (id: string) => void;
  };

export const MessagingChannelPreview = ({
  channel,
  setActiveChannel,
  latestMessagePreview,
  unread,
  blockChannel,
  showUserInfo,
}: MessagingChannelPreviewProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const openMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { channel: activeChannel, client } = useChatContext();

  const members = Object.values(channel.state.members).filter(
    ({ user }) => user?.id !== client.userID,
  );
  const image = members[0]?.user?.image;
  const name = members[0]?.user?.name
    ? [...members[0].user.name][0]
    : undefined;
  const hadUnread = !!(unread && unread > 0);
  const userId = members[0]?.user?.id;

  return (
    <div
      className={
        channel?.id === activeChannel?.id
          ? 'channel-preview__container selected'
          : 'channel-preview__container'
      }
      onClick={() => {
        setActiveChannel?.(channel);
      }}
    >
      <Avatar image={image} name={name} />
      <div className="channel-preview__content-wrapper">
        <div className="channel-preview__content-top">
          <p className="channel-preview__content-name">
            {getChannelName(members)}
          </p>
        </div>
        <div
          className={clsx(
            'channel-preview__content-message',
            hadUnread && 'unread',
          )}
        >
          {latestMessagePreview}
        </div>
      </div>
      <div className="flex flex-col items-center">
        {hadUnread && (
          <p className="channel-preview__unread-badge">
            {unread && unread > 9 ? '9+' : unread}
          </p>
        )}
        <p className="channel-preview__content-time">{getTimeStamp(channel)}</p>
      </div>
      <div
        className="cursor-pointer flex justify-center items-center p-2"
        onClick={openMenu}
      >
        <FontAwesomeIcon icon={faEllipsis} />
      </div>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            userId && showUserInfo(userId);
            handleClose();
          }}
          disabled={!userId}
        >
          <Typography variant="body" size="large">
            User info
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            channel?.id && blockChannel(channel.id);
            handleClose();
          }}
          disabled={!channel?.id}
        >
          <Typography variant="body" size="large">
            Block user
          </Typography>
        </MenuItem>
      </Menu>
    </div>
  );
};
